<style>
    #loading {
		position: absolute;
		z-index: 2;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		display: flex;
		align-items: center;
		justify-content: center;
		flex-direction: column;
        opacity: 1;
        transition: all 1.5s;
        user-select: none;
    }
    img {
		max-width: 64px;
		max-height: 64px;
	}
</style>


<div id="loading">
	<img src="media/images/loading1.gif"/>
</div>
